export default __webpack_public_path__ + "static/media/tradVScloud.45ffd184.jpg";